export default "__VITE_ASSET__dbc35790__"